export const Player_Movement = 'Player_Movement';
export const Shot = 'Shot';
export const Short_Pass = 'Short_Pass';
export const Long_Pass = 'Long_Pass';
export const GK_Kick = 'GK_Kick';
export const Cross = 'Cross';
export const Out = 'Out';



/** WEBPACK FOOTER **
 ** ./src/constants/MovementTypes.js
 **/